import React, { Component } from 'react';
import axios from 'axios';
import {
  NavLink,
  Redirect
} from 'react-router-dom';


class Profile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      date: '',
      field_group: '',
      sunumlar: []
    }
  }

  componentDidMount() {
    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
  
  	//console.log(auth);
  
    var self = this;
    this.serverRequest = axios.get('https://api.recordatifocus.com/user/' + uid + '?_format=json', {
      headers: {"Authorization":"Basic Zm9jdXM6SDg3MzczMjNu"}
    })
    .then(function(result){
      var userDate = new Date(parseInt(result.data.created["0"].value, 10)*1000);
      self.setState({
        'name': result.data.name["0"].value,
        'email': result.data.mail["0"].value,
        'field_group': result.data.field_group["0"].target_id,
        'date': userDate.toISOString()
      });
    })

        var VariablesAPI = 'https://api.recordatifocus.com/eskiler/'+ uid;
        fetch(VariablesAPI)
            .then(response => response.json())
            .then(data => this.setState({ sunumlar: data }));
  }

  render(){
    const { sunumlar } = this.state;

  
	let group;
    if (this.state.field_group == 1) {
      group = <span>{this.state.field_group} - uroonkoloji</span>
    } 
    else if (this.state.field_group == 2) {
      group = <span>{this.state.field_group} - kardiyoloji</span>
    } else {
      group = <span>grup yok</span>
    }

	let groupkub;
    if (this.state.field_group == 1) {
      groupkub = <span>ELI/D/1/2024Q2/4</span>
    } 
    else if (this.state.field_group == 2) {
      groupkub = <span>COL/RD/1/2024Q3/3</span>
    } else {
      groupkub = <span></span>
    }


  
  
  

    return (
    <div className="position-relative">
      <div className="row  justify-content-center pt-5 mb-5">
        <div className="col-md-5 mb-5">
          <div className="list-group mb-3">
            <a href="#" className="list-group-item list-group-item-action list-group-item-success">
              Kullanıcı Profili
            </a>
          </div>
          <div className="list-group mb-3">
            <a href="#" className="list-group-item list-group-item-action"><strong>Kullanıcı Adı:</strong>&nbsp;{this.state.name}</a>
            <a href="#" className="list-group-item list-group-item-action"><strong>E-posta:</strong>&nbsp;{this.state.email}</a>
            <a href="#" className="list-group-item list-group-item-action"><strong>grup: &nbsp;</strong>{group}</a>
            <a href="#" className="d-none list-group-item list-group-item-action"><strong>Üyelik Tarihi:</strong>&nbsp;{this.state.date}</a>
          </div>

          <div className="list-group mb-3">
            <a href="#" className="list-group-item list-group-item-action list-group-item-success ">
              Destek
            </a>
          </div>
          <div className="list-group">
            <a href="mailto:destek&#64;recordatifocus.com" className="list-group-item list-group-item-action">E-posta: destek&#64;recordatifocus.com</a>
          </div>


        </div>
        <div className="col-md-5 ">
		<div className="list-group mb-3"><div className="list-group-item list-group-item-action list-group-item-success">Sunum Listesi (Son 5)</div></div>
            {sunumlar.map(article =>
                <div className="list-group mb-3" key={article.title}>
                    <br/>
                    <div className="list-group-item list-group-item-action"><span>Sunum Cevaplar:</span> <NavLink to={`/sunum-${article.type.toLowerCase()}/${article.uuid}`}>{article.title}</NavLink></div>
                    <div className="list-group-item list-group-item-action"><span>Sunum Sorular:</span> <a target="_blank" href={`https://sorular.recordatifocus.com/${article.type.toLowerCase()}/${article.uuid}`}>{article.title}</a></div>
                    <div className="list-group-item list-group-item-action"><span>Sunum Link:</span> <a target="_blank" href={`https://slide.recordatifocus.com/${article.type.toLowerCase()}/${article.uuid}`}>{article.title}</a></div>
                    <div className="list-group-item list-group-item-action"><span>Sunum Tipi:</span> {article.type}</div>
                    <div className="list-group-item list-group-item-action"><span>Tarih:</span> {article.created}</div>
                </div>
            )}
        
    	</div>
      </div>
<div class="cube-code bottom-0 end-0 translate-middle-y d-inline-flex"><p class="p-0 small text-center rotated">{groupkub}</p></div>
</div>
    );
  }
}

export default Profile



// WEBPACK FOOTER //
// src/components/profile.jsx